import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  public closeAlert: boolean = false;

  constructor(public _router: Router) {
    //this._router.navigateByUrl('\LookUp')
  }

}
